module.exports = __webpack_public_path__ + "img/ps-53.901b7ba0.jpg";